<div class="container-fluid py-4 artist-container">
  <!-- Detail View (when viewing a single artist) -->
  <div *ngIf="artists.length === 1 && encryptedId; else listView">
    <div class="row mb-4">
      <div class="col-12">
        <button class="btn btn-secondary" (click)="router.navigate(['/main/artist'])">
          <i class="bi bi-arrow-left me-2"></i>Back to Artists
        </button>
      </div>
    </div>

    <div class="row" *ngIf="artists[0]">
      <div class="col-lg-10 mx-auto">
        <div class="card shadow-lg border-0 rounded-4 glass-card">
          <div class="card-header bg-primary text-white">
            <h2 class="mb-0">Artist Details</h2>
          </div>
          <div class="card-body p-4">
            <!-- View Mode -->
            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Name:</strong> {{ artists[0].artistName }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Email:</strong> {{ artists[0].emailAddress }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Phone:</strong> {{ artists[0].phoneNumber }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Additional Phone:</strong> {{ artists[0].additionalPhoneNumber || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Company:</strong> {{ artists[0].companyName || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Country:</strong> {{ artists[0].country || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>City/State:</strong> {{ artists[0].cityState || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Address:</strong> {{ artists[0].address || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Bio (Short):</strong></p>
                <p class="text-muted">{{ artists[0].artistBioShort || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Bio (Long):</strong></p>
                <p class="text-muted">{{ artists[0].artistBiogLong || 'N/A' }}</p>
              </div>
            </div>

            <hr class="my-4">

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Title of Proposed Work:</strong> {{ artists[0].titleOfProposedWork || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Type of Work:</strong> {{ artists[0].typeOfWork || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Number of Performers:</strong> {{ artists[0].numberOfPerformers || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Performer Names:</strong> {{ artists[0].performerNames || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Work Description:</strong></p>
                <p class="text-muted">{{ artists[0].workDescription || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Length of Work:</strong> {{ artists[0].lengthOfWork || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Choreographer:</strong> {{ artists[0].choreographer || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Music Credits:</strong> {{ artists[0].musicCredits || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Dance Style:</strong> {{ artists[0].danceStyle || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Type of Music:</strong> {{ artists[0].typeOfMusic || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Technical Requirements:</strong></p>
                <p class="text-muted">{{ artists[0].technicalRequirements || 'N/A' }}</p>
              </div>
            </div>

            <hr class="my-4">

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Website:</strong> <a [href]="artists[0].websiteLink" target="_blank" *ngIf="artists[0].websiteLink">{{ artists[0].websiteLink }}</a><span *ngIf="!artists[0].websiteLink">N/A</span></p>
              </div>
              <div class="col-md-6">
                <p><strong>International Artist:</strong> <span class="badge"
                    [ngClass]="{ 'bg-success': artists[0].isInternationalArtist, 'bg-secondary': !artists[0].isInternationalArtist }">{{
                    artists[0].isInternationalArtist ? 'Yes' : 'No' }}</span></p>
              </div>
            </div>

            <div class="row mb-4" *ngIf="artists[0].isInternationalArtist">
              <div class="col-md-6">
                <p><strong>P3 Visa:</strong> {{ artists[0].hasP3Visa || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>USA Travel Itinerary:</strong></p>
                <p class="text-muted">{{ artists[0].usaTravelItinerary || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Project Proposal:</strong></p>
                <p class="text-muted">{{ artists[0].projectProposal || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <p><strong>Workshop Proposal:</strong></p>
                <p class="text-muted">{{ artists[0].workshopProposal || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Expected Compensation:</strong> {{ artists[0].expectedCompensation || 'N/A' }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>How Heard About Us:</strong> {{ artists[0].howHeardAboutUs || 'N/A' }}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Agree to Terms:</strong> <span class="badge"
                    [ngClass]="{ 'bg-success': artists[0].agreeToTerms, 'bg-secondary': !artists[0].agreeToTerms }">{{
                    artists[0].agreeToTerms ? 'Yes' : 'No' }}</span></p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <p><strong>Date Submitted:</strong> {{ artists[0].date || 'N/A' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- List View -->
  <ng-template #listView>
    <div class="text-center mb-4">
      <h2 class="title">🎨 Artist Details</h2>
      <p class="subtitle">Overview of all registered artists</p>
    </div>

    <div class="card shadow-lg border-0 rounded-4 glass-card">
      <div class="table-scroll-wrapper">
        <table class="table table-hover align-middle stylish-table mb-0">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">Name</th>
              <th class="text-center">Phone</th>
              <th class="text-center">Title</th>
              <th class="text-center">City</th>
              <th class="text-center">Email</th>
              <th class="text-center">View</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let artist of artists; let i = index">
              <td class="fw-bold text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ artist.artistName }}</td>
              <td class="text-center">{{ artist.phoneNumber }}</td>
              <td class="text-wrap text-break text-center" style="max-width: 250px;">
                {{ artist.titleOfProposedWork }}
              </td>
              <td class="text-center">{{ artist.cityState }}</td>
              <td class="text-center">{{ artist.emailAddress }}</td>
              <td class="text-center">
                <i class="bi bi-eye icon-action text-success" title="View Artist Details" (click)="viewArtist(artist.artistDetailsId)"></i>
              </td>
            </tr>

            <tr *ngIf="artists.length === 0">
              <td colspan="7" class="text-center text-muted py-4">No artists found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>